(function ($) {
  'use strict';

  var $popupWrapper;

  /**
   * @param content   If string is passed no alteration will happend and the content will show as is
   *                  If an array is passed, each item of the array will be wrapped in paragraphs (multiline message)
   * @param icon      Icon to show above the message, pass in false to disable the icon
   * @constructor
   */
  this.WLCPopup = function (content, icon) {
    /**
     * The default icon
     * @type {string}
     */
    this.icon = null;

    this._style = null;

    /**
     * Callbacks
     * Registered through prototype:
     * registerCloseCallback - runs when hide is called
     */
    this._callbacks = {
      close: [],
    };

    /**
     * HTML Content/Message of the popup
     * @type {string}
     */
    this.$content = null;

    /**
     * jQuery object which holds the popup
     * @type {null}
     */
    this.$object = null;

    /**
     * jQuery object which holds the close button
     * @type {null}
     */
    this.$close = null;

    /**
     * Determines the scrolling direction
     * @type {number}
     */
    this.lastY = 0;

    /**
     * Top icon above the popup content
     */
    if (icon) {
      this.icon = new WLCIcon(icon);
    } else if (icon !== false) {
      this.icon = new WLCIcon('icon_exclamation_mark');
    }

    if (content) {
      this.setContent(content);
    }
  };

  /**
   * Close button icon
   *
   * @type {WLCIcon}
   */
  this.WLCPopup.prototype.closeButton = new WLCIcon('cross_circle');

  /**
   * Set the content of the popup
   *
   * If array is provided, it will split the elements into paragraphs
   *
   * @param content
   * @returns {*}
   */
  this.WLCPopup.prototype.setContent = function (content) {
    content =
      content.constructor === Array
        ? '<p>' + content.join('</p><p>') + '</p>'
        : content;
    this.$content = $.parseHTML('<div class="content">' + content + '</div>');

    return this;
  };

  /**
   * Helper method to allow setting a jQuery object as a content
   *
   * @param $jqueryObj
   * @returns {*}
   */
  this.WLCPopup.prototype.setObject = function ($jqueryObj) {
    this.$content = $jqueryObj;

    return this;
  };

  /**
   * Generate the popup html - wrapper, buttons, icons, content
   * Register the triggers for hiding popups
   *
   * @returns {*}
   */
  this.WLCPopup.prototype.generateHTML = function () {
    this.$close = $('<span class="close">' + this.closeButton + '</span>');
    this.$object = $('<div class="wlc-popup"></div>');
    this.$object.append(this.$close);

    if (this.icon) {
      this.$object.append('<div class="icon">' + this.icon + '</div>');
    }

    if (this._style) {
      switch (this._style) {
        case 'dark':
          this.$object.addClass('dark');
          break;
      }
    }

    if (this.$content) {
      this.$object.append(this.$content);
    }
    this.$object.wrap('<div class="popup-wrapper"></div>');

    this.$object.find('.close').on('click touchend', this.hide.bind(this));
    this.$object.on('WLCPopup:hide', this.hide.bind(this));

    return this;
  };

  /**
   * Displays the popup window
   *
   * @returns {null|*}
   */
  this.WLCPopup.prototype.show = function () {
    if (!this.$content) {
      console.log('No content provided for the popup');
    }
    if (this.$object) {
      this.$object.remove();
    }

    this.checkForPopupWrapper().generateHTML().bindEvents();

    $popupWrapper.append(this.$object);
    this.$object.find('img').each(function () {
      $(document).trigger('LazyLoad:reveal', [this]);
    });
    this.$object.fadeIn();

    if (!$popupWrapper.data('open')) {
      $('html').addClass('wlc-popup-on');
      $popupWrapper.data('open', true);
    }

    // Bind keypress to remove the popup on escape
    this.$object.attr('tabindex', 1);
    this.$object.focus();
    this.$object.on('keydown', this.keyPress.bind(this));
    return this.$object;
  };

  /**
   * Close popup on escape
   * When not in input fields
   *
   * @param e
   */
  this.WLCPopup.prototype.keyPress = function (e) {
    if (
      e.target.tagName === 'INPUT' ||
      e.target.tagName === 'TEXTAREA' ||
      e.target.tagName === 'SELECT'
    ) {
      return;
    }
    if (e.keyCode === 27) {
      this.hide();
    }
  };

  /**
   * Hide the popup, call close callbacks
   */
  this.WLCPopup.prototype.hide = function (e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.$object.remove();
    if ($popupWrapper.html() === '') {
      $('html').removeClass('wlc-popup-on');
      $popupWrapper.data('open', false);
    }

    for (var i = 0; i < this._callbacks.close.length; i++) {
      this._callbacks.close[i]();
    }
  };

  /**
   * Sets dark background style
   */
  this.WLCPopup.prototype.setDarkStyle = function () {
    this._style = 'dark';
  };

  /**
   * Helper method which generates the master popup wrapper
   * @returns {*}
   */
  this.WLCPopup.prototype.checkForPopupWrapper = function () {
    if ($popupWrapper) {
      return this;
    }
    $('body').append('<section id="wlc-popups"></section>');
    $popupWrapper = $('#wlc-popups');
    if ($popupWrapper.length > 0) {
      // When the popup background is clicked hide everything inside
      $popupWrapper.on('click touchstart', function (e) {
        if (e.target === e.currentTarget) {
          e.preventDefault();
          e.stopPropagation();
          $(this).find('.wlc-popup').trigger('WLCPopup:hide');
        }
      });
    }

    return this;
  };

  /**
   * Helper method to register callbacks on closing the popup
   * @param callback
   */
  this.WLCPopup.prototype.registerCloseCallback = function (callback) {
    if (typeof callback !== 'function') {
      console.log(
        'Invalid callback passed to WlcPopup.registerCloseCallback (must be a function): ',
        callback
      );
      return;
    }

    this._callbacks.close.push(callback);
  };

  /**
   * Binds scrolling preventing events to the popup
   */
  this.WLCPopup.prototype.bindEvents = function () {
    this.$object.on('touchstart', this.touchstart.bind(this));
    this.$object.on('touchmove', this.freezeScroll.bind(this));
  };

  /**
   * Helper to determine touchmove direction
   * @param e
   */
  this.WLCPopup.prototype.touchstart = function (e) {
    if (!e.originalEvent.touches || !e.originalEvent.touches[0]) {
      return;
    }
    this.lastY = e.originalEvent.touches[0].clientY;
  };

  /**
   * Freeze scrolling of document when reaching start/end of the popup
   * @param e
   */
  this.WLCPopup.prototype.freezeScroll = function (e) {
    if (!e.originalEvent.touches || !e.originalEvent.touches[0]) {
      return;
    }

    var y = e.originalEvent.touches[0].clientY;

    if (y > this.lastY && this.$object.scrollTop() === 0) {
      e.preventDefault();
      return false;
    } else if (y < this.lastY) {
      var scrollTop =
        this.$object.get(0).scrollHeight - this.$object.innerHeight();
      if (scrollTop === this.$object.scrollTop()) {
        e.preventDefault();
        return false;
      }
    }
  };
}).bind(window)(jQuery);
